import { render, staticRenderFns } from "./QuestionSingle.vue?vue&type=template&id=4008e813"
import script from "./QuestionSingle.vue?vue&type=script&lang=js"
export * from "./QuestionSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports